export default __webpack_public_path__ + "locales/ja-JP/ChangeUserTypeDialog.json?hash=89f27a7deca281799d1bc24c1bf62129";